function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const FileDownloadIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 7.2C27 6.2 26 5.1 25 4s-2.2-2-3.1-2.7C20.2.1 19.4 0 19 0H5.5C4.1 0 3 1.1 3 2.5V10l1 22 1-22V2.5c0-.3.2-.5.5-.5H19v7c0 .6.4 1 1 1h7l1 22 1-22c0-.4-.1-1.2-1.3-2.8zM21 8V3.2c.7.6 1.6 1.3 2.5 2.3s1.7 1.8 2.3 2.5H21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14h-6v10H8l8 8 8-8h-5V14z"
  }));
};
export default FileDownloadIcon;